import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable, { Column } from 'react-table';
import { SearchParticipantViewModel } from 'stageclip-common';

import { NextButton, PreviousButton } from 'components/table/buttons';
import { TableProps, Row } from './Table.types';
import tableStyles from 'components/table/appTable.module.scss';
import styles from './Table.module.scss';

const columns: Column[] = [
  {
    Header: 'Full name',
    accessor: ({ fullName }: SearchParticipantViewModel) => fullName,
    className: 'emphasize',
    id: 'fullName',
  },
  {
    Header: 'E-mail',
    accessor: ({ email }: SearchParticipantViewModel) => email || 'N/A',
    className: 'emphasize',
    id: 'email',
  },
  {
    Header: 'ID',
    accessor: ({ id }: SearchParticipantViewModel) => id,
    className: 'emphasize',
    id: 'id',
  },
  {
    Header: 'Subtitle',
    accessor: ({ subtitle }: SearchParticipantViewModel) => subtitle || 'N/A',
    className: 'emphasize',
    id: 'subtitle',
  },
  {
    Header: 'Second Subtitle',
    accessor: ({ secondSubtitle }: SearchParticipantViewModel) => secondSubtitle || 'N/A',
    className: 'emphasize',
    id: 'secondSubtitle',
  },
  {
    Header: 'Event name',
    accessor: ({ event: { name } }: SearchParticipantViewModel) => name || 'N/A',
    className: 'emphasize',
    id: 'eventName',
  },
  {
    Header: 'Event start time',
    accessor: ({ event: { startTime } }: SearchParticipantViewModel) => startTime,
    className: 'emphasize',
    id: 'eventStartTime',
  },
  {
    Header: 'Client name',
    accessor: ({ client: { name: clientName } }: SearchParticipantViewModel) => clientName,
    className: 'emphasize',
    id: 'clientName',
  },
];

export const Table = ({ participants, history, loading }: TableProps) => (
  <ReactTable
    loading={loading}
    columns={columns}
    className={tableStyles.appTable}
    noDataText={
      participants ? 'Sorry we could not find any results matching' : 'Please use search field to start searching'
    }
    data={participants || []}
    minRows={0}
    defaultPageSize={10}
    defaultSorted={[{ id: 'fullName', desc: false }]}
    NextComponent={NextButton}
    PreviousComponent={PreviousButton}
    getTrProps={(state: any, row: Row) => ({
      onClick: () => history.push(`events/${row.original.event.id}`),
      className: styles.row,
    })}
  />
);

export const TableContainer = withRouter(Table);
